var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appointmentSteps"},[_c('div',{staticClass:"header box-shadow-default"},[_c('el-steps',{attrs:{"active":_vm.activeStep,"align-center":""}},_vm._l((_vm.stepsData),function(item,index){return _c('el-step',{key:index,attrs:{"title":item.title}})}),1)],1),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }